module.exports = __webpack_public_path__ + "static/media/batgirl-vol5-art-of-the-crime.572c066b.jpg";